"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpMethod = void 0;
/** standard HTTP protocol methods */
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Put"] = "put";
    HttpMethod["Post"] = "post";
    HttpMethod["Delete"] = "delete";
    HttpMethod["Options"] = "options";
    HttpMethod["Head"] = "head";
    HttpMethod["Patch"] = "patch";
    HttpMethod["Trace"] = "trace";
})(HttpMethod || (exports.HttpMethod = HttpMethod = {}));
//# sourceMappingURL=http-method.js.map